export const numberOfRecommendations: number = 12;
